export default __webpack_public_path__ + "static/media/7.bd2f002e.webp";